import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";

// Page components
import Home from "./pages/Home";
import { BlogPage, BlogPostPage } from "./components/Blog";

// Admin components
import LoginPage from "../src/pages/Admin/LoginPage";
import AdminDashboard from "../src/pages/Admin/AdminDashboard";
import BlogPostForm from "./pages/Admin/BlogPostForm";
import ProtectedRoute from "./components/ProtectedRoute";

// Auth context provider
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <Router>
        <>
          <Helmet>
            <meta charSet="utf-8" />
            <link rel="icon" href="/favicon.ico" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#000000" />
            <title>Dibyanjaya's Portfolio</title>
            <meta
              name="description"
              content="My personal react portfolio ~ Dibyanjaya"
            />
            <meta
              name="keywords"
              content="portfolio, react, Dibyanjaya, web development, developer"
            />
            <meta property="og:title" content="Dibyanjaya's Portfolio" />
            <meta
              property="og:description"
              content="My personal react portfolio ~ Dibyanjaya"
            />
            <meta property="og:image" content="/og-image.png" />
            <meta property="og:url" content="https://www.dibyanjaya.com" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Dibyanjaya's Portfolio" />
            <meta
              name="twitter:description"
              content="My personal react portfolio ~ Dibyanjaya"
            />
            <meta name="twitter:image" content="/twitter-image.png" />
          </Helmet>

          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Admin Routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/create-blog" element={<BlogPostForm />} />
              <Route path="/admin/edit-blog/:id" element={<BlogPostForm />} />
            </Route>
            
            {/* Catch all - could redirect to a 404 page */}
            <Route path="*" element={<Home />} />
          </Routes>
        </>
      </Router>
    </AuthProvider>
  );
}

export default App;
